module.exports = new __parcel__URL__("svi-minority--dataset-cover.5b87e01b.png").toString();